import ClipLoader from "react-spinners/ClipLoader";
import { BeatLoader } from "react-spinners";

const CiroSpinner = ({
  loading,
  color = "#ea580c",
  useBeatLoader = false,
}: {
  loading: boolean;
  color?: string;
  useBeatLoader?: boolean;
}) => {
  if (useBeatLoader) {
    return <BeatLoader size={7} color={color} />;
  }
  return <ClipLoader size={20} loading={loading} color={color} />;
};

export default CiroSpinner;
